function formatNumber(input, scale = 1) {
    // 문자열을 숫자로 변환
    const number = typeof input === "string" ? parseFloat(input) : input;
  
    // 변환이 실패한 경우 NaN 처리
    if (isNaN(number)) return 0;
    
    // 스케일링 (기본값: 1)
    const scaledNumber = number * scale;
  
    // 세 자리마다 쉼표 추가
    return scaledNumber.toLocaleString();
}

export { formatNumber };